








import Vue from 'vue'
import IconChord from '@/assets/icons/icon-chord.svg'
import IconArpeggio from '@/assets/icons/icon-arpeggio.svg'
import hasBreakpoints from '@/mixins/hasBreakpoints'

export default Vue.extend({
  mixins: [hasBreakpoints],
  props: {
    value: { type: Boolean }
  },
  components: {
    IconChord,
    IconArpeggio
  },
  methods: {
    updateArpeggio(isArpeggio: boolean) {
      this.$emit('input', isArpeggio)
    }
  }
})
